import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BlogPost from './BlogPost';
import { fetchBlogs, fetchCategories } from '../../services/api';

function BlogInner() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagination, setPagination] = useState({
        meta: {},
        links: {}
    });
    const [categories, setCategories] = useState([]);
    const [categoriesLoading, setCategoriesLoading] = useState(true);

    useEffect(() => {
        loadBlogs(currentPage);
        loadCategories();
    }, [currentPage]);

    const loadBlogs = async (page) => {
        try {
            setLoading(true);
            setError(null);
            const response = await fetchBlogs(page);
            setPosts(response.blogs);
            setPagination(response.pagination);
        } catch (err) {
            setError(err.message || 'Failed to load blogs. Please try again later.');
            console.error('Error loading blogs:', err);
        } finally {
            setLoading(false);
        }
    };

    const loadCategories = async () => {
        try {
            setCategoriesLoading(true);
            const response = await fetchCategories();
            setCategories(response.categories || []);
        } catch (err) {
            console.error('Error loading categories:', err);
            // Don't show error to user, just log it
        } finally {
            setCategoriesLoading(false);
        }
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= (pagination.meta.last_page || 1)) {
            setCurrentPage(page);
            // Scroll to top when page changes
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    // Decode HTML entities helper function
    const decodeHtml = (html) => {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    };

    return (
        <section className="th-blog-wrapper space-top space-extra-bottom">
            <div className="container">
                <div className="row">
                    <div className="col-xxl-8 col-lg-7">
                        {loading && (
                            <div className="text-center py-5">
                                <p>Loading blogs...</p>
                            </div>
                        )}
                        
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                <strong>Error:</strong> {error}
                            </div>
                        )}
                        
                        {!loading && !error && posts.length === 0 && (
                            <div className="text-center py-5">
                                <p>No blogs found.</p>
                            </div>
                        )}
                        
                        {!loading && !error && posts.map((data) => (
                            <BlogPost
                                key={data.id}
                                blogPost={data}
                            />
                        ))}
                        
                        {!loading && !error && pagination.meta.last_page > 1 && (
                            <div className="th-pagination">
                                <ul>
                                    {pagination.meta.links && pagination.meta.links.map((link, index) => {
                                        if (link.url === null || link.page === null) {
                                            return null;
                                        }
                                        
                                        const pageNumber = link.page;
                                        const isActive = link.active;
                                        const isPrevious = link.label.includes('Previous');
                                        const isNext = link.label.includes('Next');
                                        
                                        let displayLabel = decodeHtml(link.label);
                                        if (isNext) {
                                            displayLabel = displayLabel.replace('»', '').trim();
                                        } else if (isPrevious) {
                                            displayLabel = displayLabel.replace('«', '').trim();
                                        }
                                        
                                        return (
                                            <li key={index}>
                                                <Link
                                                    className={`${isActive ? 'active' : ''} ${isNext ? 'next-page' : ''}`}
                                                    to="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (pageNumber) {
                                                            handlePageChange(pageNumber);
                                                        }
                                                    }}
                                                >
                                                    {isNext && (
                                                        <>
                                                            {displayLabel} <img src="/assets/img/icon/arrow-right4.svg" alt="" />
                                                        </>
                                                    )}
                                                    {!isNext && displayLabel}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        )}
                    </div>
                    <div className="col-xxl-4 col-lg-5">
                        <aside className="sidebar-area">
                            <div className="widget widget_search  ">
                                <form className="search-form">
                                    <input type="text" placeholder="Search" />
                                    <button type="submit">
                                        <i className="far fa-search" />
                                    </button>
                                </form>
                            </div>
                            <div className="widget widget_categories  ">
                                <h3 className="widget_title">Categories</h3>
                                {categoriesLoading ? (
                                    <p className="text-muted">Loading categories...</p>
                                ) : categories.length > 0 ? (
                                    <ul>
                                        {categories.map((category) => (
                                            <li key={category.id}>
                                                <Link to="/blog">
                                                    <img src="/assets/img/theme-img/map.svg" alt="" />
                                                    {category.name}
                                                </Link>
                                                <span>({category.blogs_count || 0})</span>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-muted">No categories available</p>
                                )}
                            </div>
                            <div className="widget  ">
                                <h3 className="widget_title">Recent Posts</h3>
                                <div className="recent-post-wrap">
                                    <div className="recent-post">
                                        <div className="media-img">
                                            <Link to="/blog/1">
                                                <img
                                                    src="assets/img/blog/recent-post-1-1.jpg"
                                                    alt="Blog Image"
                                                />
                                            </Link>
                                        </div>
                                        <div className="media-body">
                                            <h4 className="post-title">
                                                <Link className="text-inherit" to="/blog/1">
                                                    Exploring The Green Spaces Of the island maldives
                                                </Link>
                                            </h4>
                                            <div className="recent-post-meta">
                                                <Link to="/blog">
                                                    <i className="fa-regular fa-calendar" />
                                                    22/6/ 2025
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="recent-post">
                                        <div className="media-img">
                                            <Link to="/blog/1">
                                                <img
                                                    src="assets/img/blog/recent-post-1-2.jpg"
                                                    alt="Blog Image"
                                                />
                                            </Link>
                                        </div>
                                        <div className="media-body">
                                            <h4 className="post-title">
                                                <Link className="text-inherit" to="/blog/1">
                                                    Harmony With Nature Of Belgium Tour and travle
                                                </Link>
                                            </h4>
                                            <div className="recent-post-meta">
                                                <Link to="/blog">
                                                    <i className="fa-regular fa-calendar" />
                                                    25/6/ 2025
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="recent-post">
                                        <div className="media-img">
                                            <Link to="/blog/1">
                                                <img
                                                    src="assets/img/blog/recent-post-1-3.jpg"
                                                    alt="Blog Image"
                                                />
                                            </Link>
                                        </div>
                                        <div className="media-body">
                                            <h4 className="post-title">
                                                <Link className="text-inherit" to="/blog/1">
                                                    Exploring The Green Spaces Of Realar Residence
                                                </Link>
                                            </h4>
                                            <div className="recent-post-meta">
                                                <Link to="/blog">
                                                    <i className="fa-regular fa-calendar" />
                                                    27/6/ 2025
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="widget widget_tag_cloud  ">
                                <h3 className="widget_title">Popular Tags</h3>
                                <div className="tagcloud">
                                    <Link to="/blog">Tour</Link>
                                    <Link to="/blog">Adventure</Link>
                                    <Link to="/blog">Rent</Link>
                                    <Link to="/blog">Innovate</Link>
                                    <Link to="/blog">Hotel</Link>
                                    <Link to="/blog">Modern</Link>
                                    <Link to="/blog">Luxury</Link>
                                    <Link to="/blog">Travel</Link>
                                </div>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default BlogInner;
